import React, { useRef, useEffect, useState, Suspense } from 'react';
import { Row, Col, Card, Container } from 'react-bootstrap';
import styles from './Services.module.scss';

const ServiceIcon = React.lazy(() => import('./ServiceIcon'));

const Services = () => {
  const services = [
    {
      title: 'Presencial',
      appleColor: '#F6BCC5',
      description:
        'O atendimento é realizado no consultório, localizado em Botafogo ou Barra da Tijuca, conforme a sua preferência.',
      inclusions: [
        'Questionários pré-consulta.',
        'O atendimento é realizado no consultório (Botafogo ou Barra da Tijuca).',
        'Planejamento individualizado.',
        'Listas de substituições.',
        'Lista de compras.',
        'Ebooks (de acordo com o objetivo do paciente).',
        'Receitas (de acordo com o objetivo do paciente).',
        'Questionários pós-consulta.',
      ],
    },
    {
      title: 'Online',
      appleColor: '#7C987C',
      description:
        'O atendimento é similar a consulta presencial, o que muda é a forma como a avaliação nutricional será realizada.',
      inclusions: [
        'Questionários pré-consulta',
        'Consulta virtual pelo Meet ou Zoom.',
        'Planejamento individualizado.',
        'Listas de substituições.',
        'Ebooks (de acordo com o objetivo do paciente).',
        'Questionários pós-consulta.',
      ],
    },
    {
      title: 'Social',
      appleColor: '#FFCB62',
      description:
        'O atendimento é similar a consulta online, o que muda é que o paciente responde o questionário de seleção para avaliar a elegibilidade.',
      inclusions: [
        'Consulta virtual pelo Meet ou Zoom.',
        'Planejamento individualizado.',
        'Listas de substituições.',
        'Ebooks (de acordo com o objetivo do paciente).',
        'Questionários pós-consulta.',
      ],
    },
  ];

  const columnWidth = 12 / services.length;

  const descRefs = useRef<(HTMLParagraphElement | null)[]>([]);
  const listRefs = useRef<(HTMLUListElement | null)[]>([]);

  const [maxDescHeight, setMaxDescHeight] = useState(0);
  const [maxListHeight, setMaxListHeight] = useState(0);

  useEffect(() => {
    const handle = setTimeout(() => {
      const descHeights = descRefs.current.map(ref => ref?.offsetHeight || 0);
      const listHeights = listRefs.current.map(ref => ref?.offsetHeight || 0);
      setMaxDescHeight(Math.max(...descHeights));
      setMaxListHeight(Math.max(...listHeights));
    }, 100); // Espera o layout completar

    return () => clearTimeout(handle);
  }, []);


  return (
    <Container className={styles["container"]}>
      <div id="servicos">
        <Row className={[styles["data-content"], "align-items-center"].join(" ")}>
          <Col className={[styles["text-content"], styles["center"]].join(" ")}>
            <h2>Serviços</h2>
          </Col>
        </Row>

        <Row className={[styles["data-content"], "align-items-center", styles["row"]].join(" ")}>
          {services.map((service, index) => (
            <Col key={index} md={columnWidth} className={styles["text-content"]}>
              <Card className={styles["card"]}>
                <Card.Body className={styles["card-body"]}>
                  <h3 className={["card-title", "center", styles["card-title"], styles["center"]].join(" ")}>
                    <span>Atendimento</span><br />{service.title}
                  </h3>

                  <Container className={styles["container-servico"]}>
                    <Suspense fallback={<></>}>
                      <ServiceIcon
                        appleColor={service.appleColor || 'black'}
                        blockColor='#424040'
                        className={styles["img-servico"]}
                      />
                    </Suspense>
                  </Container>
                  <p
                    ref={(el: HTMLParagraphElement | null) => {
                      descRefs.current[index] = el;
                    }}
                    style={{ minHeight: maxDescHeight }}
                  >
                    {service.description}
                  </p>


                  <p className={styles["o_que_inclui"]}>O que inclui:</p>

                  <ul
                    ref={el => {
                      listRefs.current[index] = el;
                    }}
                    style={{ minHeight: maxListHeight }}
                  >
                    {service.inclusions.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </Container>
  );
};

export default Services;
